import useSWR from 'swr'
import { useParams } from 'react-router-dom'

import { getClientSummary } from '../../api'
import SummaryCards from '../ui/summaryCards'
import InvoiceList from '../invoices/list'
import { useAuth } from '../../context/auth'
import PageSectionTitle from '../ui/pageSectionTitle'

const ClientBalance = () => {
  const { id } = useParams()
  const { user } = useAuth()
  const { data: summary, isLoading: isLoadingSummary } = useSWR(
    id ? `/api/clients/${id}/summary` : null,
    getClientSummary
  )

  const currencySymbol = user?.businessDetails?.currency?.symbol

  return (
    <div>
      <SummaryCards
        data={summary ?? null}
        isLoading={isLoadingSummary}
        currencySymbol={currencySymbol}
        topSection={
          <PageSectionTitle title='Totals' />
        }
      />
      <div className='mt-2' />
      <PageSectionTitle title='Invoices' />
      <div className='my-4' />
      {id && <InvoiceList fixedClientId={id} />}
    </div>
  )
}

export default ClientBalance
